import React, { Component } from "react";
import { Form, Dropdown } from "react-bootstrap";
import UserService from "../services/user/user.service";
import AppConfig from "../config/app.config";
import { NotificationManager } from "react-notifications";
import { Backdrop } from "@mui/material";
import { CircularProgress } from "@mui/material";
import isEmail from "validator/lib/isEmail";
import ReCAPTCHA from "react-google-recaptcha";
import { Link } from "react-router-dom";

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      subjects: null,
      officeAddress: null,

      name: "",
      company: "",
      email: "",
      phone: "",
      subjectId: -1,
      message: "",
    };

    this.captchaRef = React.createRef(null);
  }

  async componentDidMount() {
    this.setState({ isLoading: true });
    // Check for subject-id in URL query params
    const params = new URLSearchParams(window.location.search);
    const subjectIdParam = params.get('subject-id');
    let subjectId = -1;
    if (subjectIdParam && !isNaN(subjectIdParam)) {
      subjectId = parseInt(subjectIdParam);
    }
    await this.getSubjects();
    await this.getOfficeAddress();
    // If subjectId from URL, set it in state
    if (subjectId !== -1) {
      this.setState({ subjectId });
    }
    this.setState({ isLoading: false });
  }

  getSubjects = async () => {
    try {
      const payload = {
        subscriptionId: AppConfig.API.SUBSCRIPTION_ID,
        verticalId: AppConfig.API.VERTICAL_ID,
        sphereUrl: AppConfig.API.SPHERE_TYPE_URL,
      };
      const res = await UserService.getContactSubjects(payload);
      if (res.data != null) {
        this.setState({ subjects: res.data });
      } else {
        NotificationManager.error("", "Could not get Subjects.", 3000);
      }
    } catch (error) {
      NotificationManager.error("", "Could not get Subjects.", 3000);
    }
  };

  getOfficeAddress = async () => {
    this.setState({ isLoading: true });
    try {
      const payload = {
        subscriptionId: AppConfig.API.SUBSCRIPTION_ID,
        verticalId: AppConfig.API.VERTICAL_ID,
        appId: AppConfig.API.APP_ID,
      };
      const res = await UserService.getOfficeAddress(payload);
      if (res.data != null) {
        this.setState({ officeAddress: res.data });
      } else {
        // NotificationManager.error("", "Could not get Address.", 3000);
      }
    } catch (error) {
      // NotificationManager.error("", "Could not get Address.", 3000);
    }
  };

  removeExtraSpace = (s) => s.replace(/\s/g, "");

  handleName = (e) => {
    this.setState({ name: e.target.value });
  };
  handleCompany = (e) => {
    this.setState({ company: e.target.value });
  };
  handleEmail = (e) => {
    this.setState({ email: e.target.value });
  };
  handlePhone = (e) => {
    const phone = this.removeExtraSpace(e.target.value);
    const result = /^\+?[0-9\b]*$/;
    if (result.test(phone)) {
      this.setState({ phone: phone });
    }
  };
  handleMessage = (e) => {
    this.setState({ message: e.target.value });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    // const captcha = this.captchaRef.current?.getValue();
    if (this.state.name.trim() === "") {
      NotificationManager.error("Please enter your name.", "", 3000);
    } else if (this.state.name.length < 3) {
      NotificationManager.error(
        "Name should be atleast 3 character long",
        "",
        3000
      );
    } else if (this.state.company.trim() === "") {
      NotificationManager.error("Please enter your company name.", "", 3000);
    } else if (this.state.email.trim() === "") {
      NotificationManager.error("Please enter your email.", "", 3000);
    } else if (!isEmail(this.state.email)) {
      NotificationManager.error("Please enter a valid email.", "", 3000);
    } else if (this.state.phone.trim() === "") {
      NotificationManager.error("Please enter your phone number.", "", 3000);
    } else if (this.state.phone.length < 10) {
      NotificationManager.error("Please enter a valid phone number.", "", 3000);
    } else if (this.state.subjectId === -1) {
      NotificationManager.error("Please select a subject.", "", 3000);
    } else if (this.state.message.trim() === "") {
      NotificationManager.error("Please enter your message.", "", 3000);
    }
    // else if (captcha == null || captcha === "") {
    //   NotificationManager.error("Captcha verification failed.", "", 3000);
    // }
    else {
      this.setState({ isLoading: true });
      try {
        const payload = {
          subscriptionId: AppConfig.API.SUBSCRIPTION_ID,
          verticalId: AppConfig.API.VERTICAL_ID,
          appId: AppConfig.API.APP_ID,
          subjectId: this.state.subjectId,
          name: this.state.name,
          email: this.state.email,
          title: this.state.company,
          phone: this.state.phone,
          description: this.state.message,
        };
        const res = await UserService.saveContactUs(payload);
        if (res.error != null) {
          if (res.error?.response?.data?.message != null) {
            NotificationManager.error(
              "",
              res.error.response.data.message,
              3000
            );
          } else if (res.error.message != null) {
            NotificationManager.error("", "Could not save contact us.", 3000);
          }
          this.setState({ isLoading: false });
        } else {
          if (res["status"]) {
            NotificationManager.success("", "Contact Us Saved.", 3000);
            this.setState({
              isLoading: false,
              name: "",
              company: "",
              email: "",
              phone: "",
              subjectId: -1,
              message: "",
            });
          } else {
            NotificationManager.error("", "Could not save contact us.", 3000);
            this.setState({ isLoading: false });
          }
        }
      } catch (error) {
        NotificationManager.error("", "Could not save contact us.", 3000);
        this.setState({ isLoading: false });
      }
      this.captchaRef.current?.reset();
    }
  };

  render() {
    return (
      <div className="ciright-contactus">
        {this.state.isLoading && (
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={this.state.isLoading}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        )}
        <div className="header-section">
          <div className="contactus-header">
            <div className="header-container">
              <Link to="https://contactus.ciright.com">Contact Us</Link>
              <Link to="https://www.myciright.com/Ciright/login.htm">
                Log in
              </Link>
            </div>
          </div>
          <div className="logo-header">
            <div className="logo-container">
              <Link to="https://www.ciright.com">
                <img
                  src={require("../assets/images/ciright-logo-white.png")}
                  className="ciright-logo"
                  alt="logo"
                />
              </Link>
              <div className="header-menu-web">
                <Link to="https://www.ciright.com/ciright-core/">
                  Ciright Core
                </Link>
                <Dropdown className="nav-item">
                  <Dropdown.Toggle
                    variant="search-toggle position-relative"
                    className="dropdown-toggle"
                  >
                    <Link to="https://www.ciright.com/products/">Products</Link>
                  </Dropdown.Toggle>
                </Dropdown>

                <Link to="https://www.ciright.com/brands/">Brands</Link>
                <Link to="https://www.ciright.com/partnership/">
                  Partnership
                </Link>
                <Dropdown className="nav-item">
                  <Dropdown.Toggle
                    variant="search-toggle position-relative"
                    className="dropdown-toggle"
                  >
                    <Link to="https://www.ciright.com/2090-2/">Company</Link>
                  </Dropdown.Toggle>
                </Dropdown>
              </div>

              <div className="header-menu-mobile">
                <Dropdown className="nav-item m-0">
                  <Dropdown.Toggle
                    href="#"
                    // as={CustomToggle}
                    variant="search-toggle position-relative"
                    className="dropdown-toggle"
                  >
                    <img
                      src={require("../assets/images/Menu.png")}
                      className="Menu-img"
                      alt="menu"
                    />
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="iq-sub-dropdown dropdown-menumobile">
                    <Link to="https://www.ciright.com/ciright-core/">
                      Ciright Core
                    </Link>
                    <Link to="https://www.ciright.com/products/">Products</Link>
                    <Link to="https://www.ciright.com/brands/">Brands</Link>
                    <Link to="https://www.ciright.com/partnership/">
                      Partnership
                    </Link>
                    <Link to="https://www.ciright.com/2090-2/">Company</Link>
                    <Link to="https://contactus.ciright.com">Contact Us</Link>
                    <Link to="https://www.myciright.com/Ciright/login.htm">
                      Log in
                    </Link>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          </div>
          <div className="header-image">
            <img
              src={require("../assets/images/header-image.png")}
              className="header-img"
              alt="header-images"
            />
            <h2>Let’s connect</h2>
          </div>
        </div>

        <div className="inner-section">
          <div className="inner-container">
            <div className="contact-connect">
              <h2>Let’s connect</h2>
              <div className="contact-form">
                <Form.Group>
                  <Form.Control
                    type="text"
                    className="form-field"
                    placeholder="Name"
                    autoComplete="off"
                    id="name"
                    onChange={this.handleName}
                    value={this.state.name}
                    required
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Control
                    type="text"
                    className="form-field"
                    placeholder="Company"
                    autoComplete="off"
                    id="company-name"
                    onChange={this.handleCompany}
                    value={this.state.company}
                    required
                  />
                </Form.Group>
              </div>
              <Form.Group>
                <Form.Control
                  type="text"
                  className="form-field"
                  placeholder="email"
                  autoComplete="off"
                  value={this.state.email}
                  onChange={this.handleEmail}
                  required
                />
              </Form.Group>
              <Form.Group>
                <Form.Control
                  type="text"
                  className="form-field"
                  placeholder="Phone"
                  autoComplete="off"
                  value={this.state.phone}
                  onChange={this.handlePhone}
                  required
                />
              </Form.Group>

              <Form.Group>
                <Form.Control
                  as="select"
                  className="form-field"
                  id="select-subject"
                  value={this.state.subjectId}
                  onChange={(e) =>
                    this.setState({ subjectId: parseInt(e.target.value) })
                  }
                >
                  <option value={-1}>Select Subject</option>
                  {this.state.subjects?.map((res, index) => {
                    return (
                      <option key={index} value={res.key}>
                        {res.value}
                      </option>
                    );
                  })}
                </Form.Control>
              </Form.Group>

              <Form.Group>
                <Form.Control
                  as="textarea"
                  className="form-field"
                  placeholder="Message…"
                  autoComplete="off"
                  id="message"
                  value={this.state.message}
                  onChange={this.handleMessage}
                  required
                />
              </Form.Group>
              <div className="total-sendbtn">
                {/* <ReCAPTCHA
                  sitekey={
                    process.env.NODE_ENV === "development"
                      ? "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"
                      : process.env.REACT_APP_RECAPTCHA_SITE_KEY
                  }
                  ref={this.captchaRef}
                /> */}
                <button
                  type="button"
                  className="sendbtn"
                  onClick={this.handleSubmit}
                >
                  SEND
                </button>
              </div>
            </div>
            <div className="contact-details">
              <a
                href="https://www.google.com/maps/place/7+Union+Hill+Rd,+Conshohocken,+PA+19428,+USA/@40.0709437,-75.3566893,13z/data=!4m6!3m5!1s0x89c6be30cd164eed:0x55d3a8f52b2b7569!8m2!3d40.0685771!4d-75.3238624!16s%2Fg%2F11c168_d9g?entry=ttu"
                rel="noreferrer"
              >
                <img
                  src={require("../assets/images/contact-us-image.png")}
                  className="map"
                  alt="map"
                />
              </a>
              <div className="contact-address">
                <p>Corporate Headquarters<br></br>
                  Ciright, Inc<br></br>
                  3025 JFK Boulevard <br></br>
                  Philadelphia, PA 19104 </p><br></br>
              </div>
              {/* {this.state.officeAddress && this.state.officeAddress != null ? (
                <p>
                  <span> Headquarters</span>
                  <br></br>{" "}
                  {this.state.officeAddress.address != null &&
                  this.state.officeAddress.address !== ""
                    ? this.state.officeAddress.address + ", "
                    : ""}
                  {this.state.officeAddress.city != null &&
                  this.state.officeAddress.city !== ""
                    ? this.state.officeAddress.city + ", "
                    : ""}
                  <br></br>
                  {this.state.officeAddress.state != null &&
                  this.state.officeAddress.state !== ""
                    ? this.state.officeAddress.state + " - "
                    : ""}
                  {this.state.officeAddress.zip != null &&
                  this.state.officeAddress.zip !== ""
                    ? this.state.officeAddress.zip + " "
                    : ""}
                  <br></br>
                  {this.state.officeAddress.county != null &&
                  this.state.officeAddress.county !== ""
                    ? this.state.officeAddress.county + " "
                    : ""}
                  <br></br>
                  {this.state.officeAddress.phone != null &&
                  this.state.officeAddress.phone !== ""
                    ? this.state.officeAddress.phone + " "
                    : ""}
                  <br></br>
                </p>
              ) : (
                ""
              )} */}
              {/*} <p>
                <span> Headquarters</span>
                <br></br>7 Union Hill Road, Conshohocken, PA 19428<br></br>
                1.855.CIRIGHT<br></br>
                <br></br>
                <span> South Asia Office</span>
                <br></br>
                Office No.702 & 703 On 7th Floor,<br></br>
                Shivalik Shilp – II<br></br>
                Keshavbaug Party Plot, Nr. Chandresh Baug,<br></br>
                Vastrapur, Ahmedabad,<br></br>
                Gujarat – 380015<br></br>
                +91 79 4800 4862
              </p> */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Home;
